import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { DISABLE_SCROLL_DATA_ATTRIBUTE } from './constants';
import { useDisableScroll } from './hooks/useDisableScroll';
import { StyledDisableScroll } from './styles/disable-scroll.styled';
export const DisableScroll = () => {
    const [active, setActive] = useState(true);
    useDisableScroll(active);
    useEffect(() => {
        return () => {
            setActive(false);
        };
    }, []);
    return _jsx(StyledDisableScroll, { [DISABLE_SCROLL_DATA_ATTRIBUTE]: true });
};
